import React from 'react';
import { Box, Grid } from '@hover/blueprint';
import styled from '@emotion/styled';
import { useMediaQuery } from '@chakra-ui/react';
import type { ISolutionPartnerTableProps } from '../../../../interfaces/ISolutionsPartners';

interface IPartnerTableProps extends ISolutionPartnerTableProps {
  desktopRows: number;
}

const LogoWrapper = styled(Box)`
  height: 52px;
  position: relative;
  align-items: center;
  justify-content: center;

  img {
    object-fit: contain !important;
  }
`;

function isLastRow(index: number, listLength: number, rows: number) {
  if (rows <= listLength) return true;
  return index >= Math.floor(listLength / rows) * rows;
}

const PartnerTable: React.FC<IPartnerTableProps> = ({
  partners,
  desktopRows,
}) => {
  const [isDesktop] = useMediaQuery('(min-width: 1280px)');

  return (
    <Grid
      templateColumns={[
        'repeat(2, 1fr)',
        'repeat(2, 1fr)',
        'repeat(2, 1fr)',
        `repeat(${desktopRows}, 1fr)`,
      ]}
      justifyContent="center"
      alignItems="center"
      columnGap={9}
      rowGap={9}
    >
      {partners.map((p, index, arr) => (
        <LogoWrapper
          key={p.key}
          w="100%"
          _after={
            isDesktop && !isLastRow(index, arr.length, desktopRows)
              ? {
                  borderBottom: '1px solid #E9E9E9',
                  content: "' '",
                  position: 'absolute',
                  left: 0,
                  bottom: '-20px',
                  width: '204px',
                  height: 0,
                }
              : undefined
          }
          _before={
            isDesktop && (index + 1) % arr.length !== 0
              ? {
                  content: "' '",
                  borderRight: '1px solid #E9E9E9',
                  position: 'absolute',
                  right: '-20px',
                  top: 0,
                  height: isLastRow(index, arr.length, desktopRows)
                    ? '60px'
                    : '96px',
                }
              : undefined
          }
        >
          {p.logo}
        </LogoWrapper>
      ))}
    </Grid>
  );
};

export default PartnerTable;
